import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthHttpInterceptor } from "@auth0/auth0-angular";
import { Observable } from "rxjs";
import { HALEON_APP_HEADER } from "../haleon/constants";

@Injectable()
export class RootAuthHttpInterceptor extends AuthHttpInterceptor {

  private shouldIntercept(request: HttpRequest<unknown>): boolean {
    const isHalenonApp = request.headers.has(HALEON_APP_HEADER);
    return !isHalenonApp;
  }

    override intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.shouldIntercept(req)) {
      return next.handle(req);
    }

    return super.intercept(req, next);
  }
}